// @mui material components
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Images
import bgImage from "assets/plus/home_bg.webp";
import MKTypography from "components/MKTypography";
import Container from "@mui/material/Container";
import { Box } from "@mui/material";
import PlanTypes from "pages/Home/sections/PlanTypes";

function Tarifas() {
  return (
    <>
      <MKBox bgColor="white">
        <MKBox
          minHeight="25rem"
          width="100%"
          sx={{
            backgroundImage: `linear-gradient(326deg, rgba(2,0,36,0.5) 0%, rgba(9,9,121,0.5) 35%, rgba(0,162,255,0.7) 100%), url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundBlendMode: "overlay",
            display: "grid",
            placeItems: "center",
          }}
        >
          <MKTypography
            variant="h1"
            color="white"
            sx={({ breakpoints, typography: { size } }) => ({
              [breakpoints.down("md")]: {
                fontSize: size["3xl"],
              },
            })}
          >
            Tarifas
          </MKTypography>
        </MKBox>
        <Card
          sx={{
            p: 2,
            mx: { xs: 2, lg: 3 },
            mt: -8,
            mb: 4,
            backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
            backdropFilter: "saturate(200%) blur(30px)",
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
          }}
        >
          <MKBox component="section" py={2}>
            <Container>
              <MKTypography variant="h3" mb={3}>
                Selecciona el tipo de servicio que se adapte a ti
              </MKTypography>

              <MKTypography variant="h6" color={"dark"}>
                Prepárate para tener una conexión sin límites elige el plan perfecto para ti y
                experimenta con Plus Internet lo que es navegar sin interrupciones.
              </MKTypography>
              <Box>
                <PlanTypes />
              </Box>
            </Container>
          </MKBox>
        </Card>
      </MKBox>
    </>
  );
}

export default Tarifas;
